import {
  TimelineAction,
  TimelineEffect,
  TimelineRow,
} from '@xzdarcy/react-timeline-editor';
import audioControl from './audioControl';
import lottieControl from './lottieControl';
import effectControl from './effectControl';
import textControl from './textControl';
import backgroundControl from './backgroundControl';
import riggedControl from './riggedControl';

export const scaleWidth = 160;
export const scale = 5;
export const startLeft = 20;

export interface CustomTimelineAction extends TimelineAction {
  data: {
    src: string;
    name: string;
    ref: any;
    imageData?: any;
    sceneId?: string;
    videoData?: string;
    provider?: string;
  };
}

export interface CusTomTimelineRow extends TimelineRow {
  id: string;
  start: number;
  end: number;
  actions: CustomTimelineAction[];
  name?: string; // Make name optional for MP3 files
  src?: string; // Allow MP3 files to have a source
}

export const mockEffect: Record<string, TimelineEffect> = {
  effect0: {
    id: 'effect0',
    name: 'Play sound',
    source: {
      start: ({ action, engine, isPlaying, time }) => {
        if (isPlaying) {
          const src = (action as CustomTimelineAction).data.src;
          audioControl.start({
            id: src,
            src,
            startTime: action.start,
            engine,
            time,
          });
        }
      },
      enter: ({ action, engine, isPlaying, time }) => {
        if (isPlaying) {
          const src = (action as CustomTimelineAction).data.src;
          audioControl.start({
            id: src,
            src,
            startTime: action.start,
            engine,
            time,
          });
        }
      },
      leave: ({ action, engine }) => {
        const src = (action as CustomTimelineAction).data.src;
        audioControl.stop({ id: src, engine });
      },
      stop: ({ action, engine }) => {
        const src = (action as CustomTimelineAction).data.src;
        audioControl.stop({ id: src, engine });
      },
    },
  },
  effect1: {
    id: 'effect1',
    name: 'Animation',
    source: {
      enter: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const characterRef = (action as CustomTimelineAction).data.ref;
        lottieControl.enter({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          characterRef,
        });
      },
      update: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const characterRef = (action as CustomTimelineAction).data.ref;
        lottieControl.update({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          characterRef,
        });
      },
      leave: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const characterRef = (action as CustomTimelineAction).data.ref;
        lottieControl.leave({
          id: src,
          startTime: action.start,
          endTime: action.end,
          time,
          characterRef,
        });
      },
    },
  },
  effect2: {
    id: 'effect2',
    name: 'Effect',
    source: {
      enter: ({ action, isPlaying, time }) => {
        if (isPlaying) {
          const src = (action as CustomTimelineAction).data.src;
          const effectRef = (action as CustomTimelineAction).data.ref;
          effectControl.enter({
            id: src,
            src,
            startTime: action.start,
            time,
            effectRef,
          });
        }
      },
      update: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const effectRef = (action as CustomTimelineAction).data.ref;
        effectControl.update({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          effectRef,
        });
      },

      leave: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const effectRef = (action as CustomTimelineAction).data.ref;
        effectControl.leave({
          id: src,
          startTime: action.start,
          endTime: action.end,
          time,
          effectRef,
        });
      },
    },
  },
  effect3: {
    id: 'effect3',
    name: 'Text',
    source: {
      enter: ({ action, isPlaying, time }) => {
        if (isPlaying) {
          const src = (action as CustomTimelineAction).data.src;
          const textRef = (action as CustomTimelineAction).data.ref;
          textControl.enter({
            id: src,
            src,
            startTime: action.start,
            endTime: action.end,
            time,
            textRef,
          });
        }
      },
      update: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const textRef = (action as CustomTimelineAction).data.ref;
        textControl.update({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          textRef,
        });
      },

      leave: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const textRef = (action as CustomTimelineAction).data.ref;
        textControl.leave({
          id: src,
          startTime: action.start,
          endTime: action.end,
          time,
          textRef,
        });
      },
    },
  },
  effect4: {
    id: 'effect4',
    name: 'Background',
    source: {
      enter: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const imageData = (action as CustomTimelineAction).data.imageData;
        const videoData = (action as CustomTimelineAction).data.videoData;
        const setBackgroundImage = (action as CustomTimelineAction).data.ref;

        backgroundControl.enter({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          setBackgroundImage,
          imageData,
          videoData,
        });
      },
      update: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const imageData = (action as CustomTimelineAction).data.imageData;
        const videoData = (action as CustomTimelineAction).data.videoData;
        const setBackgroundImage = (action as CustomTimelineAction).data.ref;

        backgroundControl.enter({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          setBackgroundImage,
          imageData,
          videoData,
        });
      },

      /* backgroundControl.enter({
         id: src,
         src,
         startTime: action.start,
         endTime: action.end,
         time,
         setBackgroundImage,
         imageData,
       });*/
      leave: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const setBackgroundImage = (action as CustomTimelineAction).data.ref;

        if (time < action.start || time > action.end) {
          backgroundControl.leave({
            id: src,
            startTime: action.start,
            endTime: action.end,
            time,
            setBackgroundImage,
          });
        }
      },
    },
  },
  effect5: {
    id: 'effect5',
    name: 'Rigged Animation',
    source: {
      enter: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const characterRef = (action as CustomTimelineAction).data.ref;
        riggedControl.enter({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          characterRef,
        });
      },
      update: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const characterRef = (action as CustomTimelineAction).data.ref;
        riggedControl.update({
          id: src,
          src,
          startTime: action.start,
          endTime: action.end,
          time,
          characterRef,
        });
      },
      leave: ({ action, time }) => {
        const src = (action as CustomTimelineAction).data.src;
        const characterRef = (action as CustomTimelineAction).data.ref;
        riggedControl.leave({
          id: src,
          startTime: action.start,
          endTime: action.end,
          time,
          characterRef,
        });
      },
    },
  },
};

export const mockData: CusTomTimelineRow[] = [];
